export default "/images/OptimizeRx.png?cd1fb478e78a7287f7b1dce07fa7b479";